import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const ROWS = [
  { label: "Role clarity", v: 32 },
  { label: "Assessment quality", v: 41 },
  { label: "Decision confidence", v: 28 },
];

export function Reframe({ theme }: { theme: Theme }) {
  return (
    <section
      style={{
        padding: "120px 0",
        borderTop: `1px solid ${theme.border}`,
        background: theme.surface,
      }}
    >
      <SectionHeader
        theme={theme}
        kicker="The reframe"
        title="The real issue is not access to candidates."
      />
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 40px",
          display: "grid",
          gridTemplateColumns: "1.2fr 1fr",
          gap: 64,
          alignItems: "start",
        }}
      >
        <div>
          <div style={{ display: "flex", alignItems: "baseline", gap: 18, marginBottom: 20 }}>
            <div
              style={{
                fontSize: 72,
                fontWeight: 600,
                letterSpacing: "-2px",
                color: theme.fg,
                lineHeight: 1,
              }}
            >
              90<span style={{ color: theme.fgMute }}>–</span>95
              <span style={{ fontSize: 40, color: theme.accentFg }}>%</span>
            </div>
            <div style={{ fontSize: 14, color: theme.fgMute, maxWidth: 240 }}>
              of sourcing comes from accessible channels such as LinkedIn and professional networks.
            </div>
          </div>
          <p style={{ fontSize: 17, color: theme.fgMute, lineHeight: 1.6, marginTop: 24 }}>
            Agencies are not uniquely accessing talent. Most companies think they need agencies
            because they lack the structure and confidence to hire without them.{" "}
            <strong style={{ color: theme.fg }}>Rarion fixes that.</strong>
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            background: theme.border,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius,
          }}
        >
          {ROWS.map((row) => (
            <div
              key={row.label}
              style={{
                background: theme.bg,
                padding: "20px 24px",
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "center",
                gap: 16,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: theme.fg,
                    marginBottom: 8,
                  }}
                >
                  {row.label}
                </div>
                <div
                  style={{
                    height: 3,
                    background: theme.border,
                    borderRadius: 2,
                    overflow: "hidden",
                    width: 260,
                  }}
                >
                  <div style={{ height: "100%", width: `${row.v}%`, background: theme.accent }} />
                </div>
              </div>
              <div style={{ fontFamily: theme.mono, fontSize: 13, color: theme.fgMute }}>
                {row.v}%
              </div>
            </div>
          ))}
          <div
            style={{
              background: theme.bg,
              padding: "16px 24px",
              fontSize: 12,
              color: theme.fgMute,
              fontFamily: theme.mono,
              letterSpacing: 0.3,
            }}
          >
            {"// the real gap"}
          </div>
        </div>
      </div>
    </section>
  );
}
